export const defaultBrowserNavigatorContextProvider = (clientId) => ({
    referrer: document.referrer,
    userAgent: navigator.userAgent,
    location: window.location.href,
    clientId,
});
export const defaultNodeJSNavigatorContextProvider = () => ({
    referrer: null,
    userAgent: null,
    location: null,
    clientId: '',
});
